import ColumnLeft from "./ColumnLeft"
import ColumnRight from "./ColumnRight"

function ModalDetailChildren({
  entries,
  ficheroId,
}: {
  entries: [string, string | number | undefined][]
  ficheroId?: string
}) {
  return (
    <div className='lg:tw-grid lg:tw-grid-cols-3 tw-gap-4 tw-h-full'>
      <ColumnLeft entries={entries} />
      <ColumnRight ficheroId={ficheroId} />
    </div>
  )
}

export default ModalDetailChildren
